<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZHbMkN/tc-custom/9780830824915.jpg?1696024902823" alt="This image is the cover for the book Joshua, Judges, Ruth, Reformation Commentary on Scripture"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Joshua, Judges, Ruth, Reformation Commentary on Scripture
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong>"Where you go I will go, and where you lodge I will lodge. Your people shall be my people, and your God my God."</strong> </p> <p>Ruth's response to her mother-in-law Naomi demonstrated both Ruth's loyalty to her family and her trust in God. The Reformers of the sixteenth century found theological significance in such Old Testament narratives. For example, German Lutheran pastor and theologian Johannes Brenz perceived in her confession a foreshadowing of the gospel: "Ruth the Moabitess is recorded in the genealogy of Christ, that it might be made known that Christ belongs not only to the Jews but also to the Gentiles."</p> <p>In this volume of the Reformation Commentary on Scripture, N. Scott Amos guides readers through a wealth of early modern commentary on the Old Testament books of Joshua, Judges, and Ruth. Readers will hear from familiar voices and discover lesser-known figures from a diversity of theological traditions, including Lutherans, Reformed, Radicals, Anglicans and Roman Catholics. Drawing upon a variety of resources—from commentaries and sermons to treatises and confessions—much of which appears here for the first time in English, this volume provides resources for contemporary preachers, enables scholars to better understand the depth and breadth of Reformation commentary, and seeks to encourage all those who would, like Ruth, declare their allegiance to God.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        N. Scott Amos
      </h2>
      
      <p class="authorDescription body article"><p>N. Scott Amos (PhD, University of St. Andrews) is professor of history at the University of Lynchburg. He is the author of <em>Bucer, Ephesians, and Biblical Humanism: The Exegete as Theologian</em> and the coeditor of <em>The Education of a Christian Society: Humanism and the Reformation in Britain and the Netherlands</em>.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?63438dfd